import { AddBulkProspect } from "../../pages";
import { BusinessController, EmployeeController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import { useFileUpload } from "use-file-upload";
import { object, string } from "yup";
import constant from "../../utils/constant";
import React, { useState } from "react";
import { observer } from "mobx-react";

const AddBulkProspectContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [file, selectFile] = useFileUpload();

  const selectClick = () => {
    selectFile({ accept: ".xlsx" });
  };

  const uploadClick = async (payload) => {
    const formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      if (value !== "") {
        formData.append(key, value);
      }
    }
    setLoading(true);
    let fileToSend;

    if (typeof file.source === "string") {
      fileToSend = await fetch(file.source)
        .then((response) => response.blob())
        .then(
          (blob) =>
            new File([blob], "name", {
              type: blob.type,
              lastModified: new Date(),
            })
        );
    }
    formData.append("prospects", fileToSend);
    const { status, errorMessage } =
      await BusinessController.createBulkProspects(formData);
    if (status === constant.Success) {
      setUploaded(true);
    } else {
      MimaToastUtil.error({
        message: errorMessage,
      });
    }
    setLoading(false);
  };

  return (
    <AddBulkProspect
      closeModal={closeModal}
      uploaded={uploaded}
      uploadClick={uploadClick}
      file={file}
      selectClick={selectClick}
      loading={loading}
    />
  );
};

export default observer(AddBulkProspectContainer);
